<article>

	<header>
		<h3>Безналичные оплаты</h3>
		
		<br />
	</header>
	
	<section>
		<form class="form-horizontal" [formGroup]="form">
			<div class="col-md-12">
				<div class="form-group">
					<label>
						{{ 'adminstat.common.invoiceNumber' | translate }}
					</label>
					
					<input
						type="text"
						class="form-control"
						formControlName="invoiceNumber"
					/>
				</div>
			</div>
		</form>
	</section>
	
	<section>
		<ngb-pagination
			pageSize="1"
			[collectionSize]="pagination.pageCount"
			[(page)]="pagination.page"
			(pageChange)="pageChange()"
			*ngIf="pagination.pageCount > 1"
		>
			<ng-template ngbPaginationNumber let-p>
				{{ getPageSymbol(p) }}
			</ng-template>
		</ngb-pagination>
	</section>
	
	<section>
		<ngb-tabset (tabChange)="beforeChange($event)" [activeId]="'tab-' + filter.filterParams.paidType">
			<ngb-tab id="tab-paid">
				<ng-template ngbTabTitle>
					Оплаченные и учтенные
				</ng-template>
				<ng-template ngbTabContent>
					<br>
				</ng-template>
			</ngb-tab>
			<ngb-tab id="tab-not_paid">
				<ng-template ngbTabTitle>
					Неоплаченные
				</ng-template>
				<ng-template ngbTabContent>
					<br>
				</ng-template>
			</ngb-tab>
		</ngb-tabset>
		
		<loading [isLoad]="tableLoader"></loading>
		
		<table class="table">
			<thead>
			<tr>
				<th>{{ 'invoiceNumber' | translate }}</th>
				<th>{{ (filter.filterParams.paidType === 'paid' ? 'datePaid' : 'dateCreate') | translate }}</th>
				<th>{{ 'domainUrl' | translate }}</th>
				<th>Организация</th>
				<th>{{ 'tariffId' | translate }}/{{ 'tariffVariant' | translate }}</th>
				<th>{{ 'amount' | translate }},&nbsp;₽</th>
				<!--<th>{{ 'applyStatus' | translate }}</th>-->
			</tr>
			</thead>
			
			<tbody>
			<tr *ngFor="let invoice of invoices">
				<td>{{ invoice.invoiceNumber }}</td>
				<td>{{ (filter.filterParams.paidType === 'paid' ? invoice.datePaid : invoice.dateCreate) | dateFormat }}</td>
				<td>{{ invoice.domainUrl }}</td>
				<td>{{ invoice.name }} ({{ invoice.INN }})</td>
				<td>{{ invoice.tariffId }}/{{ invoice.tariffVariant }}</td>
				<td>{{ invoice.amount }}</td>
				<!--<td>
					<div *ngIf="!invoice.error; else badge_danger_content">
						<span class="badge badge-pill badge-success">{{ invoice.status }}</span>
					</div>
					
					<ng-template #badge_danger_content>
						<span class="badge badge-pill badge-danger" ngbTooltip="{{ invoice.error }}">{{ invoice.status }}</span>
					</ng-template>
				</td>-->
			</tr>
			<tr>
				<th colspan="5" style="text-align: right;">Итого:</th>
				<th>{{total}}&nbsp;₽</th>
				<th></th>
			</tr>
			</tbody>
		</table>
	</section>
</article>
  
